import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { signIn, signOut, subscribeSession } from './session';
import { useSession } from './use-session';

export function SessionControls() {
  const session = useSession();
  const client = useQueryClient();
  useEffect(() => subscribeSession(() => {
    // Synchronous subscription also catches logout + login batched before a render.
    void client.cancelQueries({ queryKey: ['agent-configuration'] });
    void client.cancelQueries({ queryKey: ['agent-configuration-scopes'] });
    client.removeQueries({ queryKey: ['agent-configuration'] });
    client.removeQueries({ queryKey: ['agent-configuration-scopes'] });
    for (const mutation of client.getMutationCache().findAll({ mutationKey: ['agent-configuration'] })) client.getMutationCache().remove(mutation);
  }), [client]);
  useEffect(() => {
    // Do not retain protected configuration across sign-out, expiry or account changes.
    if (session.status !== 'signed-in') {
      void client.cancelQueries({ queryKey: ['agent-configuration'] });
      void client.cancelQueries({ queryKey: ['agent-configuration-scopes'] });
      client.removeQueries({ queryKey: ['agent-configuration'] });
      client.removeQueries({ queryKey: ['agent-configuration-scopes'] });
      for (const mutation of client.getMutationCache().findAll({ mutationKey: ['agent-configuration'] })) client.getMutationCache().remove(mutation);
    }
  }, [client, session.status]);
  return <section className="session-controls" aria-label="Session">
    <span role="status">{session.message ?? ({ unconfigured: 'Sign-in is not configured. Public preview only.', 'signed-out': 'Not signed in.', 'signed-in': 'Signed in. Permissions are enforced by the server.', loading: 'Connecting to identity provider…', expired: 'Session expired.', error: 'Sign-in unavailable.' }[session.status])}</span>
    {session.status === 'signed-in' ? <button className="button" onClick={() => void signOut()}>Sign out</button> : session.status !== 'unconfigured' ? <button className="button" disabled={session.status === 'loading'} onClick={() => void signIn()}>Sign in</button> : null}
  </section>;
}
